"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _AppIcon = _interopRequireDefault(require("./AppIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Icon = () => _react.default.createElement(_AppIcon.default, {
  color: "red",
  text: "Pr"
});

var _default = Icon;
exports.default = _default;
module.exports = exports.default;